/**
 * Geolocation-based redirect for UK and EU visitors
 * Uses ipdata.co API to match server-side PHP logic
 */
(function () {
  "use strict";

  // Detect if visitor is a search engine bot
  function isBot() {
    const botPattern = /bot|crawler|spider|crawling|google|bing|yahoo|duckduckbot|baiduspider|yandex|facebookexternalhit|slurp|teoma|ia_archiver|semrush|ahref|mj12bot|dotbot|linkedinbot|twitterbot|whatsapp|telegrambot/i;
    return botPattern.test(navigator.userAgent);
  }

  // Exit early if this is a bot - allow search engines to properly index the site
  if (isBot()) {
    console.log("Bot detected, skipping geo-redirect:", navigator.userAgent);
    return;
  }

  // Check if redirect has already been handled recently (24 hour expiration)
  const redirectHandled = localStorage.getItem("geoRedirectHandled");
  if (redirectHandled) {
    const timestamp = parseInt(redirectHandled);
    const now = Date.now();
    const twentyFourHours = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (now - timestamp < twentyFourHours) {
      return; // Skip redirect if handled within last 24 hours
    }
  }

  // Mark redirect as handled with current timestamp
  localStorage.setItem("geoRedirectHandled", Date.now().toString());

  // API configuration matching PHP script
  const API_KEY = "081424ee98f47c3048c1270423a18e6662f470522f47e51c6a27c6c3";

  // EU country codes (all 27 EU member states)
  const euCountries = [
    "AT", // Austria
    "BE", // Belgium
    "BG", // Bulgaria
    "HR", // Croatia
    "CY", // Cyprus
    "CZ", // Czech Republic
    "DK", // Denmark
    "EE", // Estonia
    "FI", // Finland
    "FR", // France
    "DE", // Germany
    "GR", // Greece
    "HU", // Hungary
    "IE", // Ireland
    "IT", // Italy
    "LV", // Latvia
    "LT", // Lithuania
    "LU", // Luxembourg
    "MT", // Malta
    "NL", // Netherlands
    "PL", // Poland
    "PT", // Portugal
    "RO", // Romania
    "SK", // Slovakia
    "SI", // Slovenia
    "ES", // Spain
    "SE", // Sweden
  ];

  // Redirect URLs - UK/EU to g-niib-uk.com, North America to Amazon US
  const redirectUrls = {
    uk: "https://g-niib-uk.com",
    eu: "https://g-niib-uk.com",
    na: "https://www.amazon.com/G-NiiB-Immunity-Elite-Synbiotic-Formula/dp/B0F7Y3WC7T?maas=maas_adg_2F8620E2F42EFCF4E3BB18355CA129FC_afap_abs&ref_=aa_maas&tag=maas",
  };

  /**
   * Get visitor's country using ipdata.co API (matching PHP logic)
   */
  function getVisitorCountry() {
    // Build API URL - using ipdata.co same as PHP script
    const apiUrl = `https://api.ipdata.co/?api-key=${API_KEY}`;

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("ipdata.co API failed");
        }
        return response.json();
      })
      .then(handleGeolocationData)
      .catch((error) => {
        console.log("Geolocation service failed:", error);
        // Fallback to alternative service
        tryFallbackService();
      });
  }

  /**
   * Fallback geolocation service
   */
  function tryFallbackService() {
    fetch("https://ipapi.co/json/")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Fallback service failed");
        }
        return response.json();
      })
      .then(handleGeolocationData)
      .catch((error) => {
        console.log("All geolocation services failed:", error);
      });
  }

  /**
   * Handle geolocation data and perform redirect (matching PHP logic)
   * @param {Object} data - Geolocation data containing country_code
   */
  function handleGeolocationData(data) {
    const countryCode = data.country_code;

    if (!countryCode) {
      console.log("No country code detected");
      return;
    }

    console.log("Detected country code:", countryCode);

    // Store country in localStorage for consistency
    localStorage.setItem("country", countryCode);

    // Check URL parameters for override
    const urlParams = new URLSearchParams(window.location.search);
    const ipParam = urlParams.get("ip");

    // UK check
    const is_GB = ipParam === "GB" || countryCode === "GB";
    if (is_GB) {
      console.log("Redirecting UK visitor to g-niib-uk.com (detected:", countryCode, ", param:", ipParam, ")");
      window.location.href = redirectUrls.uk;
      return;
    }

    // EU check - use actual EU country codes array
    const is_EU = ipParam === "EU" || euCountries.includes(countryCode);
    if (is_EU) {
      console.log("Redirecting EU visitor to g-niib-uk.com (detected:", countryCode, ", param:", ipParam, ")");
      window.location.href = redirectUrls.eu;
      return;
    }

    // North America check (US and Canada)
    const is_NA = ipParam === "NA" || countryCode === "US" || countryCode === "CA";
    if (is_NA) {
      console.log("Redirecting North American visitor to Amazon (detected:", countryCode, ", param:", ipParam, ")");
      window.location.href = redirectUrls.na;
      return;
    }

    console.log("Visitor from non-target region:", countryCode);
  }

  /**
   * Initialize geolocation redirect with delay to ensure page load
   */
  function initializeRedirect() {
    // Small delay to ensure proper page initialization
    setTimeout(getVisitorCountry, 100);
  }

  // Execute redirect logic when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeRedirect);
  } else {
    initializeRedirect();
  }
})();
